import { queryOptions, useQuery } from "@tanstack/react-query";
import { getMotionAmplificationRawVideos } from "../clients/motion-amplification";

/**
 * Cache namespace for the raw-video picker. Invalidate this key after an
 * upload changes which existing videos can be selected.
 */
export const motionAmplificationRawVideosQueryKey = [
  "motion-amplification",
  "raw-videos",
] as const;

/**
 * Fetches raw videos from the Modality BFF using the shared cache namespace.
 * The result follows TanStack Query's default stale-time, retry, and garbage
 * collection behavior unless a caller overrides those options.
 */
export const motionAmplificationRawVideosQueryOptions = () =>
  queryOptions({
    queryKey: motionAmplificationRawVideosQueryKey,
    queryFn: async () => (await getMotionAmplificationRawVideos()).rawVideos,
  });

/**
 * Returns the TanStack Query result for selectable raw videos. Consumers use
 * its `data`, pending, and error states; callers should invalidate the shared
 * raw-video key after mutations that add an eligible upload.
 */
export function useMotionAmplificationRawVideosQuery() {
  return useQuery(motionAmplificationRawVideosQueryOptions());
}
